<div class="container-fluid">
  <div class="row mb-3">
    <p-toast position="top-center" key="error"></p-toast>
    <p-toast
      position="top-center"
      key="expired"
      (onClose)="router.navigate(['forgotpassword'])"
    />
      <p-toast
        position="top-center"
        key="success"
        (onClose)="router.navigate(['login'])"
      ></p-toast>
      <div class="col-lg-3"></div>
      <div class="col-lg-6">
        <form
          [formGroup]="form"
          (submit)="resetPassword()"
          autocomplete="off"
          class="p-4 p-md-5 shadow bg-light h-100"
          >
          <small class="fw-semibold">Reset Password</small>
          <div class="card flex justify-content-center mt-4">
            <p-floatlabel variant="on">
              <p-password
                [style]="{ width: '100%' }"
                [inputStyle]="{ width: '100%' }"
                formControlName="password"
                [toggleMask]="true"
                [disabled]="disabled"
                size="small"
                >
                <ng-template pTemplate="header">
                  <h6>Pick a password</h6>
                </ng-template>
                <ng-template pTemplate="footer">
                  <p-divider></p-divider>
                  <p class="mt-2">Password Requirements:</p>
                  <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                    <li>At least one lowercase</li>
                    <li>At least one uppercase</li>
                    <li>At least one numeric or special character</li>
                    <li>Must contain between {{ passwordMinLength }} and 20 characters</li>
                  </ul>
                </ng-template>
              </p-password>
              <label htmlFor="password">Password</label>
            </p-floatlabel>
          </div>
          <div class="card d-flex justify-content-end mt-4 p-float-label">
            <p-password
              [style]="{ width: '100%' }"
              [inputStyle]="{ width: '100%' }"
              id="confirm"
              formControlName="confirm"
              [toggleMask]="true"
              [disabled]="disabled"
              >
              <ng-template pTemplate="header">
                <h6>Pick a password</h6>
              </ng-template>
              <ng-template pTemplate="footer">
                <p-divider></p-divider>
                <p class="mt-2">Password Requirements:</p>
                <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                  <li>At least one lowercase</li>
                  <li>At least one uppercase</li>
                  <li>At least one numeric or special character</li>
                  <li>Must contain between {{ passwordMinLength }} and 20 characters</li>
                </ul>
              </ng-template>
            </p-password>
            <label htmlFor="confirm">Confirm Password</label>
          </div>
          <button
            class="btn btn-primary mt-2"
            [disabled]="loading || disabled"
            type="submit"
            >
            @if (loading) {
              <span
                class="spinner-border spinner-border-sm me-1"
              ></span>
            }
            Reset Password
          </button>
        </form>
      </div>
      <div class="col-lg-3"></div>
    </div>
  </div>
